import { jwtDecode } from 'jwt-decode'

export const PREVIEW_TOKEN_HEADER = 'x-portal-preview-token'

const PREVIEW_TOKEN_PARAM = 'preview_token'
const PREVIEW_TOKEN_KEY = 'ecp_preview_token'
const PREVIEW_EXPIRED_KEY = 'ecp_preview_expired'

const readItem = (key: string): string | null => {
  try {
    return window.sessionStorage.getItem(key)
  } catch {
    return null
  }
}

const writeItem = (key: string, value: string | null) => {
  try {
    if (value === null) {
      window.sessionStorage.removeItem(key)
    } else {
      window.sessionStorage.setItem(key, value)
    }
  } catch {
    return
  }
}

export const capturePreviewToken = () => {
  try {
    const url = new URL(window.location.href)
    const token = url.searchParams.get(PREVIEW_TOKEN_PARAM)

    if (token === null) return

    writeItem(PREVIEW_TOKEN_KEY, token || null)
    writeItem(PREVIEW_EXPIRED_KEY, null)

    url.searchParams.delete(PREVIEW_TOKEN_PARAM)
    window.history.replaceState(
      window.history.state,
      '',
      `${url.pathname}${url.search}${url.hash}`
    )
  } catch {
    return
  }
}

export const getPreviewToken = (): string | undefined =>
  readItem(PREVIEW_TOKEN_KEY) || undefined

export const getPreviewTokenHeaders = (): Record<string, string> => {
  const token = getPreviewToken()

  return token ? { [PREVIEW_TOKEN_HEADER]: token } : {}
}

export const getPreviewRevisionId = (): string | undefined => {
  const token = getPreviewToken()

  if (!token) return undefined

  try {
    const { revision_id } = jwtDecode<{ revision_id?: unknown }>(token)

    return typeof revision_id === 'string' && revision_id
      ? revision_id
      : undefined
  } catch {
    return undefined
  }
}

export const clearPreviewToken = () => writeItem(PREVIEW_TOKEN_KEY, null)

export const expirePreviewToken = () => {
  clearPreviewToken()
  writeItem(PREVIEW_EXPIRED_KEY, 'true')
}

export const isPreviewExpired = () => readItem(PREVIEW_EXPIRED_KEY) === 'true'

export const dismissPreviewExpired = () => writeItem(PREVIEW_EXPIRED_KEY, null)
